import { Button, Center, Stack, Text } from '@mantine/core';

export function CallEndedScreen({
  onDone,
  message = 'The provider ended this session.',
  doneLabel = 'Return to portal',
}: {
  onDone?: () => void;
  message?: string;
  doneLabel?: string;
}): JSX.Element {
  return (
    <Center h="100dvh" p="md">
      <Stack align="center" gap="md">
        <Text size="xl" fw={600}>
          Call has ended
        </Text>
        <Text c="dimmed" ta="center">
          {message}
        </Text>
        {onDone ? <Button onClick={onDone}>{doneLabel}</Button> : null}
      </Stack>
    </Center>
  );
}
